
module.exports = function(){
  return {
    defs: [],
    symbol: "<symbol id=\"scroll-to-button-arrow\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"currentColor\" d=\"M8 8l4.293 3.723c.39.37 1.024.37 1.414 0a.907.907 0 000-1.335L8 5l-5.707 5.388a.907.907 0 000 1.335c.39.37 1.024.37 1.414 0L8 8z\"/></symbol>"
  };
};
module.exports.SvgStoreTransformed = true;
